/** Scope 1: direct emissions, as a table page - ADR-0212.
 *
 * The page is `scopeTable/ScopePage.tsx`, shared with Scope 2 because the two are the same screen
 * over different figures: a title card with Import and Add, tiles, one filter line and one grid, in
 * three tabs (Figures, By month, Data quality). What this file used to hold - the KPI strip, the
 * category bars and the data-quality panel - is those tabs now, and the sentences it carried are
 * behind the info controls (`infoText.ts`, section `scope1`).
 */

import { ScopeTablePage } from "./scopeTable/ScopePage";

export function Scope1Screen() {
  return <ScopeTablePage scope="1" />;
}
